import { Modal } from "antd";
import styled from "styled-components";

export const ModalStyled = styled(Modal)`
  background: ${({ theme }) => theme?.colors?.theme?.contentBgOpaque}
  display: flex;
  padding: var(--Sizes---size-xl, 32px);
  flex-direction: column;
  align-items: center;
  gap: var(--Sizes---size-xl, 32px);
  align-self: stretch;

  &.ant-modal-content {
    width: 100%;
    min-width: 100%;
    max-width: 404px;
  }
`;

export const TitleStyled = styled.h1`
  flex: 1 0 0;
  margin-top: 32px;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Red Hat Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */

  span.brandColor3 {
    color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  }
`;

export const ContentBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Sizes---size-xl, 32px);
  align-self: stretch;
`;